import React, { useCallback } from "react";
import { isFormValid } from "../../FormValidation/index";
import getConfig from "./config";

const withFormHandlers = (Component) => (props) => {
  const onSubmit = useCallback(
    (event) => {
      event.preventDefault();

      if (isFormValid(props, getConfig(props))) {
        props.history.push(`/application/thank-you`);
      }
    },
    [props],
  );

  return <Component {...props} onSubmit={onSubmit} />;
};

export default withFormHandlers;
